export default __webpack_public_path__ + "static/media/Bloodbarbs.fd4646e9.jpg";